<template lang="pug">
  WtTile(vertical)
    WtTile(horizontal)
      .column.is-flex.is-align-items-center.is-full-width
        .pr-3
          WtTile.overview-main-details
            WtEntityAvatar.mr-4(
              :image="logo"
              size-class="is-64x64"
              is-rounded
            )
        .column
          p.has-text-grey.is-size-4 {{organizationName}}
          p.has-text-black.is-size-3.is-bold {{ name }}
          p.has-text-black.is-size-6 {{ membersCount }} Members | Created {{ creationDateFormatted }}
    WtTile(vertical)
      .column.is-full-widthp.has-text-black.is-size-5.is-bold  All time data
      .column.is-full-width
        WtStatColumn(icon="orange-shoe" name="Total Steps" :value="totalSteps.toLocaleString()")
      .column.is-full-width
        WtStatColumn(icon="purple-rope" name="Total Activities" :value="totalActivities.toLocaleString()")


</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtEntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar";
import WtStatColumn from "@@/WtStatColumn/WtStatColumn";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { mapGetters } from "vuex";

export default {
  name: "OrganizationMobileOverview",

  components: {
    WtTitle,
    WtTile,
    WtEntityAvatar,
    WtStatColumn
  },

  mixins: [dateUtilityMixin],

  props: {
    organizationName: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: null
    },
    creationDate: {
      type: String,
      default: null
    },
    membersCount: {
      type: Number,
      default: null
    },
    teams: {
      type: Array,
      default: () => []
    },
    totalSteps: {
      type: Number,
      default: null
    },
    totalActivities: {
      type: Number,
      default: null
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),
    creationDateFormatted() {
      if (this.creationDate) {
        return this.date(
          Date.parse(this.creationDate),
          "DATE_FORMAT_SHORT_MONTH"
        ).formatted;
      }
      return "";
    }
  },

  methods: {}
};
</script>

<style lang="sass" scoped>
.is-full-width
  width: calc(100vw - 3rem)
.is-bold
  font-family: $family-sans-serif-bold
</style>
